import { reducerKey } from './reducer';

/**/
/* SELECTORS */
/**/

/** Returns the app data state slice. */
const extractFrom = state => state[reducerKey];

export const getOrders = state => {
  const data = extractFrom(state);

  return data.orders;
};

export const getOrderDetails = (state, orderId) => {
  const data = extractFrom(state);

  return data.orderDetails[orderId];
};

export const getOrdersLoading = state => {
  const data = extractFrom(state);

  return data.ordersLoading;
};

export const getOrdersCurrentPage = state => {
  const data = extractFrom(state);

  return data.page;
};

export const getOrdersNextPage = state => {
  const data = extractFrom(state);

  return data.nextPage;
};

export const getOrdersPreviousPage = state => {
  const data = extractFrom(state);

  return data.previousPage;
};

export const getOrdersCount = state => {
  const data = extractFrom(state);

  return data.count;
};
